import { useEffect } from 'react';
import ReactGA from 'react-ga4';

export const trackingId = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID || '';
const appVersion = "0.1.0"

const useGoogleAnalytics = () => {

    useEffect(() => {
        if (trackingId) {
            try {
                ReactGA.initialize([
                    {
                        trackingId,
                        gaOptions: {
                            anonymizeIp: true
                        }
                    }
                ]);
                ReactGA.set({ app_version: appVersion });
            } catch (error) {
                console.log("Error initializing Google Analytics", { Error: error });
            }
        }
    }, []);

    const setOption = (key: string, value: unknown) => {
        ReactGA.set({ [key]: value });
    };

    const sendData = (type: string, data: object) => {
        ReactGA.send({ hitType: type, ...data });
    };

    const trackPageView = (pagePath?: string) => {
        if (!pagePath) {
            pagePath = window.location.href;
        }

        setOption('app_version', appVersion);
        sendData("pageview", { page: pagePath });
    };

    const trackEvent = (category: string, action: string, label?: string, value?: number) => {
        setOption('app_version', appVersion);
        ReactGA.event({ category, action, label, value });
    };

    return {
        setOption,
        trackPageView,
        trackEvent,
    };
};

export default useGoogleAnalytics;